import React, { useEffect, useState } from 'react'

import { Button, Grid, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { AvaliationDpo, JustifyDialog } from './components'
import { Card, LoadingFeedback } from 'components'

import useIncidentManegement from 'hooks/useIncidentManegement'

import constants from 'constants/index'

const AvaliationStep = ({ type, refresh }) => {
  const [loading, setLoading] = useState(false)
  const [isReopened, setIsReopened] = useState(false)
  const [justifyDialogOpen, setJustifyDialogOpen] = useState(false)

  const {
    incident,
    isDpo,
    isShow,
    wantsToAdvanceStep,
    resetAdvanceStep,
    handleNext,
    activeButton,
    setActiveButton,
  } = useIncidentManegement()

  const incidentTypeTest =
    incident?.incidentType === constants.documents.TEST_INCIDENT_VALUE

  const avaliationStep = incident?.incidentManegementSteps?.find(
    (step) => step.step === 'avaliation',
  )

  const alreadyAnswered =
    type !== 'create' && avaliationStep?.concluded && !isReopened

  const handleOpenJustifyDialog = () => setJustifyDialogOpen(true)

  useEffect(() => {
    if (!isDpo && !incidentTypeTest) {
      return setActiveButton(alreadyAnswered)
    }

    if (incidentTypeTest || isDpo) {
      if (wantsToAdvanceStep) {
        resetAdvanceStep()
      }
      if (!activeButton) {
        setActiveButton(true)
      }
    }
  }, [])

  useEffect(() => {
    if (wantsToAdvanceStep && !isDpo && !incidentTypeTest) {
      resetAdvanceStep()
      handleNext()
      setActiveButton(true)
    }
  }, [wantsToAdvanceStep])

  return (
    <>
      <Card
        title="Avaliação do Incidente"
        id={constants.incidents.INCIDENT_MAIN_DRIVER_STEP_6}
        actionButton={
          (isDpo || incidentTypeTest) && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleOpenJustifyDialog}
              disabled={!alreadyAnswered || isShow}
            >
              Reabrir Parecer
            </Button>
          )
        }
      >
        <LoadingFeedback open={loading} />
        {isDpo || incidentTypeTest || alreadyAnswered ? (
          <AvaliationDpo
            type={type}
            shouldDisable={alreadyAnswered}
            setIsReopened={setIsReopened}
            refresh={refresh}
          />
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Alert severity="info">
                <Typography>
                  Por favor, aguarde! O Encarregado de Proteção de Dados(DPO)
                  foi notificado e está avaliando seu incidente.
                </Typography>
              </Alert>
            </Grid>
          </Grid>
        )}
      </Card>
      <JustifyDialog
        open={justifyDialogOpen}
        setOpen={setJustifyDialogOpen}
        setLoading={setLoading}
        setIsReopened={setIsReopened}
        incident={incident}
        refresh={refresh}
      />
    </>
  )
}

export default AvaliationStep
